import '../../resources/css/dashboard/MapGroup.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab, Row, Col, Nav, Card, Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';
import HoodMap from '../../components/dashboard/HoodMap';
import { getDeviceDetail } from '../../actions/dashboard/index';
import { getDevicesQuantityInState, getDevicesQuantityInCity, queryDevicesByCity } from '../../actions/map/index';
import Loading from '../../components/common/Loading';

class MapGroup extends Component {
    state = {
        extendCityMenu: {},
        initialComplete : false,
        defaultCountry: window.CONFIG.MAP_DEFAULT.defaultCountry,
        defaultState: null,
        defaultCity: null,
        selectCountry: window.CONFIG.MAP_DEFAULT.defaultCountry,
        selectCity: {},
        stateAvatarColors: ['#E9AB06', '#c268e7', '#2e8ddf', '#19ae51', '#adae19', '#e95d06', '#6882e7', '#a5bd1f', '#e877dd', '#eb9595', 
            '#a49e93', '#39c2d1', '#73cb4d', '#3d9aab', '#a38462', '#ffa770', '#ca9cbf', '#b11fbd', '#38822b', '#4165db']
    }

    clickMap = (mac) => {
        const { idToken, getDeviceDetail } = this.props;
        getDeviceDetail(idToken, mac);
    }

    selectCountry = (eventKey, e) => {
        const { idToken, getDevicesQuantityInState } = this.props;
        const { selectCity } = this.state;

        if (eventKey) {
            // load state info
            getDevicesQuantityInState(idToken, eventKey);

            this.setState({
                selectCountry: eventKey
            });

            setTimeout(() =>{
                // re-load map wait  this.setState selectCountry complete
                if (selectCity[eventKey]) {
                    this.selcetCity(selectCity[eventKey], null);
                }
            }, 200);            
        }
    }

    selcetCity = (eventKey, e) => {
        const { idToken, queryDevicesByCity } = this.props;
        const { selectCity, selectCountry } = this.state;

        if (eventKey) {
            // load state info
            queryDevicesByCity(idToken, eventKey);

            let cityObj = selectCity;
            cityObj[selectCountry] = eventKey;
            
            this.setState({
                selectCity: cityObj
            });
        }
    }

    toggleState = (e, stateName) => {
        const { idToken, getDevicesQuantityInCity } = this.props;
        const elTarget = e.target;        
        if (elTarget) {
            let { extendCityMenu } = this.state;            
            // toggle value
            extendCityMenu[stateName] = extendCityMenu[stateName] ? false : true;
            if (extendCityMenu[stateName]) {
                getDevicesQuantityInCity(idToken, stateName);
            }
            this.setState({
                extendCityMenu: extendCityMenu
            })
        }
    }

    cityListContent = (stateName) => {
        const { cityQuantityMap, cityLoadingMap } = this.props;
        let retContents;
        if (cityLoadingMap && cityLoadingMap[stateName]) {
            const cityLoading = cityLoadingMap[stateName];
            const cityQuantity = cityQuantityMap[stateName];
            let loadingCount = 0;
            for (let loadingKey in cityLoading) {
                if (cityLoading[loadingKey]) {
                    loadingCount++;
                }                
            }
            if (loadingCount) {
                let cityContents = [];

                cityQuantity.forEach(element => {
                    const cityName = element.long_name;
                    const cityTitle = element.long_name + " (" + element.total + ") ";
    
                    if (cityLoading[cityName]) {
                        let cityContent = (
                            <Nav.Item key={cityName} className='area-city-link'>
                                <Nav.Link eventKey={cityName} onSelect={this.selcetCity} className='city-link'>
                                    <Row>
                                        <Col sm={2} ></Col>
                                        <Col sm={8}>{cityTitle}</Col>
                                        <Col sm={2} ></Col>
                                    </Row>
                                </Nav.Link>
                            </Nav.Item>
                        );
                        
                        cityContents.push(cityContent);
                    }
                });

                retContents = (
                    <Nav variant="pills" className="flex-column">
                        { cityContents }
                    </Nav>
                );
            } else {
                retContents = (
                    <Loading loading={true}></Loading>
                ); 
            }
            
        } else {
            retContents = (
                <Loading loading={true}></Loading>
            ); 
        }

        return retContents;
    }

    stateListContent = (countryName) => {
        const { stateQuantityMap, stateLoadingMap } = this.props;
        const { extendCityMenu, stateAvatarColors } = this.state;    

        let retStateContents;
        if (stateLoadingMap && stateLoadingMap[countryName]) {
            const stateLoading = stateLoadingMap[countryName];
            const stateQuantity = stateQuantityMap[countryName];

            let loadingCount = 0;
            for (let loadingKey in stateLoading) {
                if (stateLoading[loadingKey]) {
                    loadingCount++;
                }                
            }
            if (loadingCount) {
                retStateContents = [];
                let stateCount = 0;

                stateQuantity.forEach(element => {
                    const stateName = element.long_name;
                    if (stateLoading[stateName]) {
                        // get citys menu content
                        let cityContents = this.cityListContent(stateName);
                        // get extend citys or collapse citys
                        let btnToggleCityMenu;
                        if (extendCityMenu[stateName]) {
                            btnToggleCityMenu = (<span className='icon-btn-collapse'></span>);
                        } else {
                            btnToggleCityMenu = (<span className='icon-btn-expand'></span>);
                        }                        
                        let stateAvatarColor = stateCount % 20;
                        stateCount++;

                        const StateAvatarIcon = (props) =>(
                            <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" className={props.class}>
                                <g id="hood-list" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g transform="translate(-1258.000000, -21.000000)" fill={props.fill} fillRule="nonzero" id="header">
                                        <g>
                                            <g id="account" transform="translate(1248.000000, 16.000000)">
                                                <g id="avatar" transform="translate(10.000000, 5.000000)">
                                                    <g id="ico_avatar">
                                                        <circle id="Oval" cx="15" cy="15" r="14"></circle>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        )

                        const stateShortName = countryName === 'Taiwan' ? 'TW' : element.short_name;

                        let stateContent = (
                            <div key={stateName} className='area-map-continent'>
                                <Card className="text-center">
                                    <Card.Title>
                                        <Row>
                                            <Col sm={4} className='area-continent-shot-name'>
                                                <StateAvatarIcon class="icon-state-avatar" fill={stateAvatarColors[stateAvatarColor]}/>
                                                <span className='area-continent-short-name'>{stateShortName}</span>
                                            </Col>
                                            <Col sm={8} className='area-continent-long-name'>
                                                {stateName}
                                            </Col>
                                        </Row>
                                    </Card.Title>
                                    <Card.Body>
                                        <Row>
                                            <Col sm={6} className='area-continent-status-title'>
                                                Online
                                            </Col>
                                            <Col sm={6} className='area-continent-status-title'>
                                                Offline
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6} className='area-continent-status'>
                                                {element.online}
                                            </Col>
                                            <Col sm={6} className='area-continent-status'>
                                                {element.offline}
                                            </Col>
                                        </Row>
                                        <Collapse in={this.state.extendCityMenu[stateName]}>
                                            <div className="area-collapse-city">{cityContents}</div>
                                        </Collapse>
                                    </Card.Body>
                                    <Card.Footer id={stateName} className="area-btn-continent-expand" onClick={(e) => this.toggleState(e, stateName)}>
                                        { btnToggleCityMenu }
                                    </Card.Footer>
                                </Card>
                            </div>                    
                            );
                        
                            retStateContents.push(stateContent);
                        }
                    });
            } else {
                retStateContents = (
                    <Loading loading={true}></Loading>
                ); 
            }            
        } else {
            retStateContents = (
                <Loading loading={true}></Loading>
            ); 
        }

        return retStateContents;
    }

    countryTabsContent = () => {
        const { countryQuantity, countryLoading, idToken, devices, deviceLoading } = this.props;
        const { selectCity, selectCountry } = this.state;
        let retTabContents;
        let detailMapContent;
        if (deviceLoading) {
            detailMapContent = (
                <Loading loading={deviceLoading}></Loading>
            );
        } else {
            detailMapContent = (
                <HoodMap idToken={idToken} devices={devices} clickMap={this.clickMap}></HoodMap>
            );
        }
        
        if (countryLoading) {
            retTabContents = (
                <Loading loading={countryLoading}></Loading>
            );
        } else {
            retTabContents = [];
            // gen contry code
            countryQuantity.forEach(element => {
                const tabEventKey = element.long_name;
                const tabTitle = element.long_name + " (" + element.total + ") ";

                let stateContents = this.stateListContent(element.long_name);

                let tabContent = (
                    <Tab key={ tabEventKey } eventKey={ tabEventKey } title={ tabTitle } className='area-map-group-tab'>
                        <Tab.Container defaultActiveKey={ selectCity[selectCountry] }>
                            <Row>
                                <Col sm={2}>
                                    { stateContents }
                                </Col>
                                <Col sm={10} className='area-map-display-col'>
                                    <div className='area-map-detail'>
                                        <Tab.Content>
                                            <Tab.Pane eventKey={ selectCity[selectCountry] }>
                                                { detailMapContent }
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>                                    
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Tab>
                );
                
                retTabContents.push(tabContent);
            });
        }

        return retTabContents;
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        const { initialComplete, defaultCountry, defaultState } = this.state;
        const { mapStatus, stateQuantityMap, cityQuantityMap } = this.props;

        if (!initialComplete && prevProps.mapStatus !== mapStatus) {
            if ("GET_STATE_QUANTITY_SUCCESS" === mapStatus) {
                let stateList = stateQuantityMap[defaultCountry];
                if (stateList && stateList.length > 0) {
                    let firstState = stateList[0].long_name;
                    this.toggleState({target:true}, firstState);
                    this.setState({
                        defaultState : firstState
                    });
                }
            } else if ("GET_CITY_QUANTITY_SUCCESS" === mapStatus) {
                let cityList = cityQuantityMap[defaultState];
                if (cityList && cityList.length > 0) {
                    let firstCity = cityList[0].long_name;
                    this.selcetCity(firstCity, null);
                    this.setState({
                        defaultCity : firstCity
                    });
                }
            } else if ("QUERY_DEVICES_SUCCESS" === mapStatus) {
                this.setState({
                    initialComplete : true
                });
            }

        }
    }

    componentDidMount() {
        const { idToken, getDevicesQuantityInState } = this.props;
        const { defaultCountry } = this.state;
        if (defaultCountry) {
            // load state info
            getDevicesQuantityInState(idToken, defaultCountry);
        }
    }

    render() {
        let tabContents = this.countryTabsContent();
        let tabsContents = (
            <Loading loading={true}></Loading>
        );

        const { initialComplete } = this.state;
        if (initialComplete) {
            tabsContents = (
                <Tabs defaultActiveKey={ this.state.defaultCountry } id="country-map-tabs" className='area-map-group-tab-menu' onSelect={ this.selectCountry}>
                    { tabContents }
                </Tabs>
            );
        }

        return (
            <div className='area-map-group'>
                { tabsContents }
            </div>            
        )
    }
}

MapGroup.propTypes = {
    idToken: PropTypes.string.isRequired,
    devices: PropTypes.array
}

const mapStateToProps = (state, ownProps) => {  
    return {
        idToken: state.logindReducers.idToken,
        mapStatus: state.mapReducers.status,
        countryQuantity: state.mapReducers.countryQuantity,
        countryLoading: state.mapReducers.countryLoading,
        stateQuantityMap: state.mapReducers.stateQuantityMap,
        stateLoadingMap: state.mapReducers.stateLoadingMap,
        cityQuantityMap: state.mapReducers.cityQuantityMap,
        cityLoadingMap: state.mapReducers.cityLoadingMap,
        devices: state.mapReducers.devices,
        deviceLoading: state.mapReducers.deviceLoading
    }
  }
  
  export default connect(
    mapStateToProps,
    { getDeviceDetail, getDevicesQuantityInState, getDevicesQuantityInCity, queryDevicesByCity }
  )(MapGroup)